import useSideNavCollapse, {
  useSideNavVisible,
} from "@/utils/useSideNavCollapse";

export const useSideNavWidth = () => {
  const sideNavVisible = useSideNavVisible();

  const [isCollapsed] = useSideNavCollapse();
  return sideNavVisible ? (isCollapsed ? 84 : 168) : 0;
};
